var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('v-card-text',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }